import { render } from "./QuestDetailedGrouped.vue?vue&type=template&id=bf4f2060&scoped=true"
import script from "./QuestDetailedGrouped.vue?vue&type=script&lang=js"
export * from "./QuestDetailedGrouped.vue?vue&type=script&lang=js"

import "./QuestDetailedGrouped.vue?vue&type=style&index=0&id=bf4f2060&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf4f2060"]])

export default __exports__